import * as Yup from 'yup';

import { ErrorMessages } from '@scripts/constants';

export const inputSchema = Yup.object().shape({
    email: Yup.string().email(ErrorMessages.EMAIL).required(ErrorMessages.REQUIRED),
});
